// extracted by mini-css-extract-plugin
export var details = "_hj-0";
export var inspectorPopover = "_hj-1";